import { Divider, Form, Input, Radio } from "antd";
import { FormInstance } from "antd/lib";
import React from "react";
import { IntelligenceFormFieldsEnum } from "../../enum";

export const ModeSave = "save";
export const ModeSaveAsNew = "save_as_new";

export const ContentModalSaveConfig: React.FC<{
  form: FormInstance<any>;
  handleUpdateSoftTitleConfig: (title?: string, description?: string) => void;
  showMode?: boolean;
  isOwnerConfig?: boolean;
  optionMode?: string;
  setOptionMode?: React.Dispatch<React.SetStateAction<string>>;
}> = ({ form, handleUpdateSoftTitleConfig, showMode, isOwnerConfig = false, optionMode, setOptionMode }) => {
  const [title, setTitle] = React.useState<string>("");
  const [description, setDescription] = React.useState<string>("");

  React.useLayoutEffect(() => {
    const isAddCopyIntoTitle = showMode && optionMode === ModeSaveAsNew;
    setTitle(form.getFieldValue(IntelligenceFormFieldsEnum.TITLE) + (isAddCopyIntoTitle ? "(copy)" : ""));
    setDescription(form.getFieldValue(IntelligenceFormFieldsEnum.DESCRIPTION));
  }, [form, optionMode, showMode]);

  React.useEffect(() => {
    handleUpdateSoftTitleConfig(title, description);
  }, [title, description, handleUpdateSoftTitleConfig]);

  return (
    <div>
      <Divider className="my-2" />
      {showMode && isOwnerConfig && optionMode && (
        <Radio.Group
          className="flex flex-col"
          value={optionMode}
          onChange={(e) => {
            setOptionMode?.(e.target.value);
          }}
        >
          <Radio value={ModeSave}>Update this exploration</Radio>
          <Radio value={ModeSaveAsNew}>Save as new exploration</Radio>
        </Radio.Group>
      )}
      <div
        style={{
          display: showMode && optionMode === ModeSave ? "none" : "block",
          marginTop: 12,
        }}
      >
        <Form.Item
          label={
            <div className="w-[80px] flex justify-start">
              <span>Title</span>
            </div>
          }
          required
        >
          <Input
            value={title}
            onChange={(e) => {
              form.setFieldValue(IntelligenceFormFieldsEnum.IS_CUSTOM_TITLE, true);
              setTitle(e.target.value);
            }}
          />
        </Form.Item>
        <Form.Item
          label={
            <div className="w-[88px] flex justify-start">
              <span>Description</span>
            </div>
          }
        >
          <Input
            value={description}
            onChange={(e) => {
              setDescription(e.target.value);
            }}
          />
        </Form.Item>
      </div>
    </div>
  );
};
